class PerfectQueenWhatsApp extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-pq-whatsapp-toggle]');
    this.panel = this.querySelector('[data-pq-whatsapp-panel]');
    this.button?.addEventListener('click', () => this.toggle());
    document.addEventListener('click', (event) => {
      const contactLink = event.target.closest('a[href="#whatsapp-contact"], a[href="/#whatsapp-contact"]');
      if (!contactLink) return;

      event.preventDefault();
      this.open();
    });
    document.addEventListener('click', (event) => {
      const contactLink = event.target.closest('a[href="#whatsapp-contact"], a[href="/#whatsapp-contact"]');
      if (!this.hiddenPanel && !this.contains(event.target) && !contactLink) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close(true);
    });
    if (window.location.hash === '#whatsapp-contact') this.open();
  }
  get hiddenPanel() { return this.panel?.hidden ?? true; }
  toggle() { this.hiddenPanel ? this.open() : this.close(true); }
  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    this.panel.querySelector('a')?.focus();
  }
  close(returnFocus = false) {
    if (!this.panel || this.panel.hidden) return;
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    if (returnFocus) this.button.focus();
  }
}
if (!customElements.get('pq-whatsapp')) customElements.define('pq-whatsapp', PerfectQueenWhatsApp);
